<template>
  <div class="approval-list-wrap">
    <v-list
      v-for="applItem in GET_APPL_USER_LIST"
      :key="applItem.agreeSeq"
      class="approval-item"
    >
      <div>
        <v-list-item class="pl-0">

          <!-- 결재자 정보 -->
          <v-list-item-content>
            <!-- 결재구분 -->
            <v-list-item-icon class="align-self-center">
              <v-chip
                  label
                  v-text="
                applItem.applTypeCd == 10 ? '결재' : applItem.applTypeCdNm
              "
                  class="step"
                  :class="stepChipClass(applItem.applTypeCd)"
              ></v-chip>
            </v-list-item-icon>
            <div class="d-flex flex-row justify-start  align-center">
              <v-list-item-title
                class="name"
                v-text="applItem.agreeEmpAlias"
              ></v-list-item-title>
              <v-list-item-subtitle
                ><span v-text="applItem.jikwee" class="position"></span
                ><span
                  v-if="applItem.org !== ' '"
                  v-text="applItem.org"
                  class="divider position"
                ></span>
                <span  v-text="applItem.ymd"  class=" divider position app-date"></span>
              </v-list-item-subtitle>
            </div>
          </v-list-item-content>

          <!-- 결재상태 -->
          <v-list-item-icon>
            <v-chip
              v-if="GET_APPL_SEQ_EXIST == 'Y' && applItem.agreeStatusCd != null"
              class="status"
              :class="statusChipClass(applItem.agreeStatusCd)"
            >
              {{ applItem.agreeStatusCdNm }}
              <v-icon size="16">
                {{
                  applItem.applTypeCd == 30
                    ? 'mdi-note-text'
                    : applItem.agreeStatusCd == 30
                    ? 'mdi-close'
                    : applItem.agreeStatusCd == 20
                    ? 'mdi-check'
                    : ''
                }}
              </v-icon>
            </v-chip>
          </v-list-item-icon>
        </v-list-item>

        <!-- (결재단계) 결재의견 -->
        <v-list-item
          v-if="applItem.memo != null && applItem.memo != ''"
          class="pa-0"
        >
          <!-- <v-list-item-action></v-list-item-action> -->
          <v-list-item-content class="pt-0 pb-5">
            <v-sheet class="opinion-wrap" color="lightGrey">
              <v-list-item-subtitle class="opinion-title"
                >의견</v-list-item-subtitle
              >
              <div class="opinion-desc" v-html="applItem.memo"></div>
            </v-sheet>
          </v-list-item-content>
        </v-list-item>
        <!--v-divider></v-divider-->
      </div>
    </v-list>
  </div>
</template>

<script>
/* 결재자 리스트 */
import { mapGetters } from 'vuex';
import { getApplLine } from '@/api/ela';

export default {
  data: () => ({}),
  computed: {
    ...mapGetters('ELA', [
      'GET_APPL_USER_LIST',
      'GET_APPL_SEQ_EXIST',
      'SET_APPL_USER_LIST',
      'GET_ELA_APPL_PARAM',
      'GET_MGR_USER_LIST',
    ]),
    ...mapGetters('DIALOG', ['GET_DIALOG_PARAM']),

    ...mapGetters(['GET_USER_DATA', 'GET_AUTHPG']),

    stepChipClass() {
      return applTypeCd => {
        return {
          // 결재구분코드(30:기안, 10:결재)
          draft: applTypeCd == 30,
          approval: applTypeCd == 10,
        };
      };
    },
    statusChipClass() {
      return agreeStatusCd => {
        return {
          // 결재상태코드(10:결재요청, 20:결재완료, 30:반려)
          accept: agreeStatusCd == 20,
          reject: agreeStatusCd == 30,
        };
      };
    },
  },

  async mounted() {

    const params = {
      ssnEnterCd: this.GET_USER_DATA.ssnEnterCd,
      searchApplSeq: this.GET_DIALOG_PARAM.applSeq,
      applSeqExist: 'Y',
    };

    let that = this;

    if (that.GET_AUTHPG !== 'A') {
      setTimeout(async function () {
        let response = await getApplLine(params);

        that.$store.commit(
          'ELA/SET_APPL_USER_LIST',
          response.data.data.applLine,
        );
        that.$store.commit('ELA/SET_MGR_USER_LIST', response.data.data.mgrLine);
        console.dir('AppLine : ' + JSON.stringify(that.GET_APPL_USER_LIST));
        console.dir('MgrLine : ' + JSON.stringify(that.GET_MGR_USER_LIST));
      }, 300);
    }
  },
};
</script>

<style></style>
